import {
  API_FLAG,
  SCHEDULE_STATUS,
  PARTNER_APPROVAL_NAME,
  WORKER_TYPES,
  SYSTEM_WORKER_COUNT,
} from './constants';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';

const workEditDefaultState = ({ isWorkSchedule, view }) => ({
  isShowPopupError: false,
  keySubWork: 1,
  keyMainWork: 1,
  lengthOfListMainWorkTypes: 0,
  isShowMainSubDropdown: false,
  progress_date_from: null,
  progress_date_to: null,
  listMainWorkTypes: [],
  listSubWorkTypes: [],
  isExistOxygenLack: '',
  companyItemOrders: [],
  companyItemSettings: [],
  scheduleId: view.state.id, // 予定ID
  fieldId: sessionStorage.getItem('field_id'), // 現場ID
  roleId: LocalStorageService.getRoleId(), // ユーザー種別
  companyBranchId: sessionStorage.getItem('company_branch_id'), // 支店ID
  validate: {
    invalid: false, // 入力内容エラー
    validated: false,
    messages: {}, // エラー内容
  },
  isFifteen: false,
  approvedFlag: false,
  partnerCompanyApprovalFlag: false, // 協力会社承認フラグ
  foremanUserId: null,
  workTimes: [], // 現場に設定されている作業時間
  workTime: {}, // 現場に設定されている作業時間を格納
  options: {}, // プルダウン初期表示用データ
  loaded: false, // プルダウンの情報が取得できたか
  requiredInput: {
    // 必須項目
    columns: [
      'work_date',
      'field_tree_id', // 協力会社ID
      'job_id', // 職種
      'foreman_user_id', // 職長
      'contents', // 作業内容
      'work_dayworkers', // 人工
      'dayworker_type',
    ],
    count: 2, // 期間・人工はデフォルトセット
    total: null,
  },
  image: {
    // キープラン画像
    path: '', // 画像URL
    json: '',
    edited: false, // 画像操作済みフラグ
    keyplanId: '', // キープランID
  },
  // プルダウンの初期name
  pulldownName: {
    company_name: '', // 協力会社名
    job_name: '', // 職種名
    foreman_user_name: '', // 職長名
    a_item_name: '', // 作業場所A名
    b_item_name: '', // 作業場所B名
    c_item_name: '', // 作業場所C名
    d_item_name: '', // 作業場所D名
    manager_user_name: '', // 元請担当者名
  },
  fieldItem: {}, // 項目設定
  updatingFlag: false, // 連続更新防止フラグ
  formValues: {
    main_work_type_name: null,
    sub_work_type_name: null,
    isMainTypeRequired: false,
    isSubTypeRequired: false,
    workPlaceRequireType: 0,
    main_work_type_id: null,
    sub_work_type_id: null,
    userValueChangeFlag: false, // ユーザー操作フラグ
    // eslint-disable-next-line no-undef
    schedule_flag: isWorkSchedule
      ? SCHEDULE_STATUS.schedule.id
      : SCHEDULE_STATUS.result.id, // 予定フラグ
    work_hour_zone: sessionStorage.getItem('work_hour_zone'), // 作業時間帯
    work_date: '', // 作業予定日
    field_tree_id: null, // 協力会社ID
    job_id: null, // 職種
    foreman_user_id: null, // 職長
    a_item_id: null, // 作業場所A
    b_item_id: null, // 作業場所B
    c_item_id: null, // 作業場所C
    d_item_id: null, // 作業場所D
    contents: '', // 作業内容
    non_japanese: '0', // 外国人
    woman: '0', // 女性
    dayworker_type: WORKER_TYPES.contractor.id, // 契約
    option1: '', // 予備欄1 (旧：予想される危険)
    option1_must_flag: 0,
    option2: '', // 予備欄2 (旧：安全指示事項)
    option2_must_flag: 0,
    option3: '', // 予備欄3 (旧：他職への注意事項)
    option3_must_flag: 0,
    option4: '', // 予備欄4
    option4_must_flag: null,
    option5: '', // 予備欄5
    option5_must_flag: null,
    option6: '', // 予備欄6
    option6_must_flag: null,
    option7: '', // 予備欄7
    option7_must_flag: null,
    option8: '', // 予備欄8
    option8_must_flag: null,
    option9: '', // 予備欄9
    option9_must_flag: null,
    option10: '', // 予備欄10
    option10_must_flag: null,
    option11: '', // 予備欄11
    option11_must_flag: null,
    option12: '', // 予備欄12
    option12_must_flag: null,
    option13: '', // 予備欄13
    option13_must_flag: null,
    option14: '', // 予備欄14
    option14_must_flag: null,
    option15: '', // 予備欄15
    option15_must_flag: null,
    option16: '', // 予備欄16
    option16_must_flag: null,
    option17: '', // 予備欄17
    option17_must_flag: null,
    option18: '', // 予備欄18
    option18_must_flag: null,
    option19: '', // 予備欄19
    option19_must_flag: null,
    option20: '', // 予備欄20
    option20_must_flag: null,
    memo: '', // 指示書備考欄
    hot_work_code: '', // 火気種別
    hot_work_start: '', // 火気開始
    hot_work_end: '', // 火気終了
    oxygen_lack_dangerous_work_upper: '', // 酸欠
    oxygen_lack_dangerous_work_lower: '', // 酸欠
    oxygen_lack_education_complete_upper: '', // 酸欠
    oxygen_lack_education_complete_lower: '', // 酸欠
    manager_user_id: null, // 元請担当者
    groups: 'A', // 印刷グループ
    state_handling_flag: '', // 中止フラグ
    display_fifteen_minute_flg: false, // 人工を15分単位で計算する
    work_dayworkers: [
      {
        // 人工
        dayworker_type: WORKER_TYPES.contractor.id,
        working_temp_person: SYSTEM_WORKER_COUNT[0].id,
        working_temp_hour: 0.0,
        dayworker: 0,
      },
    ],
    work_early_times: [
      {
        // 早出
        id: '',
        fixed_unfixed_type: WORKER_TYPES.contractor.id,
        working_temp_person: SYSTEM_WORKER_COUNT[0].id,
        working_temp_hour: 0.0,
        overtime_start: '',
        earlytime_end: '',
      },
    ],
    work_over_times: [
      {
        // 残業
        id: '',
        fixed_unfixed_type: WORKER_TYPES.contractor.id,
        working_temp_person: SYSTEM_WORKER_COUNT[0].id,
        working_temp_hour: 0.0,
        overtime_start: '',
        earlytime_end: '',
      },
    ],
    work_key_plan_image: {
      // キープラン
      id: '',
      key_plan_category_code: '',
      edited_image: '',
    },
    partner_company_approval_updated_at: '', // 協力会社承認更新日時
    partner_company_approval_updated_user_name: '', // 協力会社承認更新者
  },
  usePartnerCompanyApprovalFlag:
    SessionStorageService.getUsePartnerCompanyApprovalFlag() === API_FLAG.On, // 協力会社承認機能ご利用フラグ
  partnerApprovalName: isWorkSchedule
    ? PARTNER_APPROVAL_NAME.schedule
    : PARTNER_APPROVAL_NAME.result, // 協力会社承認機能_承認名: 受領 or 確定
  isFirstLoaded: false, // 初回ロードフラグ

  workGroupDataUpdateFlag: false,
  // 作業がWorkGroupと合算される可能性がある場合を検知するためのフラグ
  loadedKeyPlanData: [],
  reflectWorkTotal: !isWorkSchedule ? 0 : null,
  workDayWorkersStatus: null,
  checkInReflectToResultFlag: false,
  isShowSptDropdown: false,
  sptDateFrom: null,
  sptDateTo: null,
});

export default workEditDefaultState;



// WEBPACK FOOTER //
// ./src/utilities/workEditDefaultState.js